// ProtectedRoute.js
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/authContext";
import { ADMIN_USER_IDS, ADMIN_EMAILS } from "../utils/adminUtils";

export default function ProtectedRoute({ requireAdmin = false, requireHost = false, children }) {
  const { ready, user, claims, isAdmin, role } = useAuth();
  const location = useLocation();

  // Show loading state instead of null to prevent routing issues
  if (!ready) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-400 mx-auto"></div>
          <p className="mt-4 text-gray-300">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    console.log('🔒 ProtectedRoute: No user, redirecting to login', { path: location.pathname });
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  
  // For admin routes, do comprehensive check (same as LoginPage) to avoid race conditions
  if (requireAdmin) {
    const isAdminByClaims = claims?.admin === true || role === "admin";
    const isAdminByUid = ADMIN_USER_IDS.includes(user.uid);
    const isAdminByEmail = user.email && ADMIN_EMAILS.includes(user.email);
    const isActuallyAdmin = isAdmin || isAdminByClaims || isAdminByUid || isAdminByEmail;
    
    console.log('🔒 ProtectedRoute: Admin check', {
      path: location.pathname,
      isAdmin,
      isAdminByClaims,
      isAdminByUid,
      isAdminByEmail,
      isActuallyAdmin,
      uid: user.uid,
      email: user.email
    });
    
    if (!isActuallyAdmin) {
      console.log('❌ ProtectedRoute: Not admin, redirecting to not-authorized');
      return <Navigate to="/not-authorized" replace />;
    }
  }
  
  if (requireHost && !claims?.host) {
    return <Navigate to="/not-authorized" replace />;
  }
  
  return children;
}
